import React from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  Typography,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

import PackageDeliveryTypeApi from "Services/PackageDeliveryType";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PackageDeliveryTypeDelete = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleDelete = () => {
    if (!id) return;
    dispatch(showLoader("Deleting please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Package Delivery Type Deleted Successfully",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "success",
          })
        );
        handleClose();
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error deleting Package Delivery Type",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };

    PackageDeliveryTypeApi.deletePackageDeliveryType(id).then(onSuccess, onFailure);
  };

  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      fullWidth
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle className={classes.headerBar}>
        <Typography className={classes.headerTitle}>Delete Package Delivery Type</Typography>
        <IconButton aria-label="close" onClick={handleClose} className={classes.closeIconBtn}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.contentContainer}>
        <DeleteOutlineIcon style={{ fontSize: 50, color: "#d32f2f" }} />
        <Typography className={classes.messageText}>
          Are you sure you want to delete this Package Delivery Type? This action cannot be undone.
        </Typography>

        <Box className={classes.buttonContainer}>
          <Button variant="outlined" onClick={handleClose} className={classes.cancelBtn}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleDelete} className={classes.deleteBtn}>
            Delete
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PackageDeliveryTypeDelete;
